import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import classNames from 'classnames';

const GlobalMenuGroupPres = ({ text, children, isOpen, toggleGroup }) => {
  const menuItemClass = classNames('menu-item', {
    open: isOpen,
  });

  //// console.log('@menuItemsClass', menuItemClass);

  return (
    <Fragment>
      <ListItem button className={menuItemClass} onClick={toggleGroup}>
        <ListItemText primary={text} className="menu-text" />
        {isOpen ? <ExpandLess className="icon" /> : <ExpandMore className="icon" />}
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className="menu-group-children">
          {children}
        </List>
      </Collapse>
    </Fragment>
  );
};

GlobalMenuGroupPres.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleGroup: PropTypes.func.isRequired,
};

export default GlobalMenuGroupPres;
